<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    吉祥站<br>
站点介绍<br>
吉祥站位于龙岗大道与吉祥路交汇处。2、A出入口有耳鼻喉研究所，B出入口有港龙医院，C出入口出去是龙岗中心城，汇集万科广场、世贸广场、龙岗出入境办政大厅、社保局等等。D出入口有公园大地、龙城公园。该站为高架站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:26	23:07	3号线	2分15-20秒	4分30秒<br>
双龙	06:17	00:05	3号线	2分15-20秒	4分30秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:26	23:06	3号线	3分15秒	5分钟<br>
双龙	06:20	00:05	3号线	3分15秒	5分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:26	00:06	3号线	3分15秒	5分钟<br>
双龙	06:20	01:05	3号线	3分15秒	5分钟<br><br>

站点出口信息<br><br>
A出入口:<br>
龙岗大道（南）、吉祥南路、龙岗中心医院耳鼻咽喉科医院<br><br>
B出入口:<br>
龙岗大道（南）、湖广通中商大厦<br><br>
C出入口:<br>
龙岗大道（北）、西浦西路、风临域、万科天誉、鸿基幼儿园、西浦西街<br><br>
D出入口:<br>
龙岗大道（北）、正中风临国际、吉祥中路、深圳机场龙岗候机楼、鸿基花园、鸿进花园、龙城中学<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 吉祥地铁站<br>
309路, 366路,651路, M266路, M268路, M275路, M320路,M359路,M367路,T1路, 深惠2线<br><br>
B出入口:<br>
公交站名： 吉祥地铁站<br>
309路, 366路,651路, M266路, M268路, M275路, M320路,M359路,M367路,T1路, 深惠2线<br><br>
C出入口:<br>
公交站名： 吉祥地铁站<br>
309路,366路,651路,M266路,M268路 ,M275路,M320路,M359路,M367路,T1路, 深惠2线<br><br>
D出入口:<br>
公交站名： 吉祥地铁站<br>
309路,366路,651路,M266路,M268路 ,M275路,M320路,M359路,M367路,T1路, 深惠2线<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "sanhaoxian",
          title: "3号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>






